import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { contactInfo } from '../mock';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer style={{
      background: '#242A32',
      color: 'white',
      padding: '3rem 1.2rem 1.5rem'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '2rem',
          marginBottom: '2rem'
        }}>
          {/* Brand Column */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem' }}>
              <div style={{
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%' }}>
                  <circle cx="50" cy="50" r="45" fill="none" stroke="#987D9C" strokeWidth="2"/>
                  <circle cx="50" cy="50" r="8" fill="#987D9C"/>
                  <circle cx="50" cy="20" r="6" fill="#768597"/>
                  <circle cx="80" cy="50" r="6" fill="#BCA182"/>
                  <circle cx="50" cy="80" r="6" fill="#FCC9C7"/>
                  <circle cx="20" cy="50" r="6" fill="#b8d1ba"/>
                  <line x1="50" y1="50" x2="50" y2="20" stroke="#999999" strokeWidth="1"/>
                  <line x1="50" y1="50" x2="80" y2="50" stroke="#999999" strokeWidth="1"/>
                  <line x1="50" y1="50" x2="50" y2="80" stroke="#999999" strokeWidth="1"/>
                  <line x1="50" y1="50" x2="20" y2="50" stroke="#999999" strokeWidth="1"/>
                </svg>
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: '1.125rem' }}>CRN</div>
                <div style={{ fontSize: '0.625rem', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Healing Starts Within</div>
              </div>
            </div>
            <p style={{ fontSize: '0.875rem', lineHeight: '1.6', opacity: 0.8 }}>
              Supporting recovery facilities with hydration-based cellular recovery across North America and Latin America.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontSize: '1rem', fontWeight: 500, marginBottom: '1rem' }}>Quick Links</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <button onClick={() => scrollToSection('about')} style={{
                background: 'none',
                border: 'none',
                color: 'white',
                opacity: 0.8,
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: '0.875rem',
                transition: 'opacity 0.2s'
              }} onMouseEnter={(e) => e.target.style.opacity = '1'} onMouseLeave={(e) => e.target.style.opacity = '0.8'}>
                About Us
              </button>
              <button onClick={() => scrollToSection('benefits')} style={{
                background: 'none',
                border: 'none',
                color: 'white',
                opacity: 0.8,
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: '0.875rem',
                transition: 'opacity 0.2s'
              }} onMouseEnter={(e) => e.target.style.opacity = '1'} onMouseLeave={(e) => e.target.style.opacity = '0.8'}>
                Key Benefits
              </button>
              <button onClick={() => scrollToSection('how-it-works')} style={{
                background: 'none',
                border: 'none',
                color: 'white',
                opacity: 0.8,
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: '0.875rem',
                transition: 'opacity 0.2s'
              }} onMouseEnter={(e) => e.target.style.opacity = '1'} onMouseLeave={(e) => e.target.style.opacity = '0.8'}>
                How It Works
              </button>
              <button onClick={() => scrollToSection('faq')} style={{
                background: 'none',
                border: 'none',
                color: 'white',
                opacity: 0.8,
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: '0.875rem',
                transition: 'opacity 0.2s'
              }} onMouseEnter={(e) => e.target.style.opacity = '1'} onMouseLeave={(e) => e.target.style.opacity = '0.8'}>
                FAQ
              </button>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 style={{ fontSize: '1rem', fontWeight: 500, marginBottom: '1rem' }}>Contact Us</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <a href={`tel:${contactInfo.phone}`} style={{
                color: 'white',
                opacity: 0.8,
                textDecoration: 'none',
                fontSize: '0.875rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                transition: 'opacity 0.2s'
              }} onMouseEnter={(e) => e.currentTarget.style.opacity = '1'} onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}>
                <Phone size={16} />
                {contactInfo.phone}
              </a>
              <a href={`mailto:${contactInfo.email}`} style={{
                color: 'white',
                opacity: 0.8,
                textDecoration: 'none',
                fontSize: '0.875rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                transition: 'opacity 0.2s',
                wordBreak: 'break-word'
              }} onMouseEnter={(e) => e.currentTarget.style.opacity = '1'} onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}>
                <Mail size={16} />
                {contactInfo.email}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '1.5rem',
          marginTop: '2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <p style={{ fontSize: '0.875rem', opacity: 0.7, margin: 0 }}>
            © {new Date().getFullYear()} The Cellular Recovery Network. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            <button style={{
              background: 'none',
              border: 'none',
              color: 'white',
              opacity: 0.7,
              cursor: 'pointer',
              fontSize: '0.875rem',
              transition: 'opacity 0.2s'
            }} onMouseEnter={(e) => e.target.style.opacity = '1'} onMouseLeave={(e) => e.target.style.opacity = '0.7'}>
              Privacy Policy
            </button>
            <button style={{
              background: 'none',
              border: 'none',
              color: 'white',
              opacity: 0.7,
              cursor: 'pointer',
              fontSize: '0.875rem',
              transition: 'opacity 0.2s'
            }} onMouseEnter={(e) => e.target.style.opacity = '1'} onMouseLeave={(e) => e.target.style.opacity = '0.7'}>
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
